import { PermissionTableRowType } from '../../../../../../types/common/PermissionType';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../../../constants/service/common/userPermissions';
/*
생성/등록/추가 : create
삭제/제거 : delete
편집/수정 : update
상세페이지/보기 : read
리스트/보기 : readList
엑셀다운로드 : downloadExcel
*/
export const COMMON_MENU: PermissionTableRowType = {
  name: '공통',
  key: 'MESSAGE_MANAGE',
  subRows: [
    {
      name: '문자 메시지 발송',
      key: PERMISSION_SUBJECTS.MESSAGE,
      permissions: [PERMISSION_ACTIONS.CREATE],
    },
  ],
};
